import React from 'react'
import MacroCircle from './macro-circle'
import './daily-goals.css'
import Text from '@components/kit/text'

interface DailyGoalsProps {
  calories: { goal: number; value: number }
  carbs: { goal: number; value: number }
  protein: { goal: number; value: number }
  fat: { goal: number; value: number }
}

function DailyGoals({ calories, carbs, protein, fat }: DailyGoalsProps) {
  return (
    <div className='daily-goals'>
      <div style={{ paddingBottom: '16px' }}>
        <Text ml='12' font='display.16.bold'>
          Daily nutrition
        </Text>
      </div>

      <div className='daily-goals__card'>
        <div className='daily-goals__grid'>
          <MacroCircle
            goal={calories.goal}
            value={calories.value}
            color='#FF8719'
            unit=''
            title='Calories'
          />

          <MacroCircle
            goal={carbs.goal}
            value={carbs.value}
            color='#2DB1EA'
            unit='g'
            title='Carbs'
          />

          <MacroCircle
            goal={protein.goal}
            value={protein.value}
            color='#15C2B8'
            unit='g'
            title='Protein'
          />

          <MacroCircle
            goal={fat.goal}
            value={fat.value}
            color='#8B5CF6'
            unit='g'
            title='Fat'
          />
        </div>
      </div>
    </div>
  )
}

export default DailyGoals
